import { useQuery } from "@apollo/react-hooks";

import { EventsInput } from "@hubcapp/graphql";

import calendarEvents from "../graph-ql/calendarEvents.graphql";

const useQueryCalendarEvents = (
  input?: EventsInput & { instructorId: string },
) =>
  useQuery(calendarEvents, {
    variables: {
      ...input,
    },
    skip: !input?.instructorId,
    fetchPolicy: "network-only",
  });

export default useQueryCalendarEvents;
